export const LiftedLogo = (props: {
  class?: string;
  theme?: "light" | "dark";
}) => {
  const theme = () => (props.theme === "light" ? "white" : "#26253E");

  return (
    <svg
      class={props.class}
      width="602"
      height="148"
      viewBox="0 0 602 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.3901 147.146H116.397V118.756H28.3901V147.146Z"
        fill="#FFA4E0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M49.0261 15.0318L72.3941 32.9018L28.3901 66.5518V30.8118L49.0261 15.0318Z"
        fill="#FFA4E0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M116.397 118.756H144.788V88.2614L116.398 66.5514L116.397 118.756Z"
        fill="#FFA4E0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M116.397 147.146H133.827C139.879 147.146 144.788 142.239 144.788 136.185V118.756H116.397V147.146Z"
        fill="#431FAF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M95.761 15.0318L72.394 32.9018L116.398 66.5518V30.8118L95.761 15.0318Z"
        fill="#7FF5FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M49.0259 15.0318L72.3939 32.9018L95.7609 15.0318L79.0509 2.25382C77.0869 0.751817 74.7399 -0.000183105 72.3939 -0.000183105C70.0469 -0.000183105 67.7009 0.751817 65.7359 2.25382L49.0259 15.0318Z"
        fill="#431FAF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M144.496 55.4292C143.921 52.9872 142.517 50.7872 140.484 49.2322L116.397 30.8122V66.5512L144.787 88.2612V57.9392C144.787 57.0852 144.686 56.2432 144.496 55.4292Z"
        fill="#431FAF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.39 66.5513L-0.000976562 88.2613V118.756H28.39V66.5513Z"
        fill="#7FF5FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M-0.000488281 118.756V136.185C-0.000488281 137.698 0.306512 139.14 0.860512 140.451C2.38651 144.058 5.78651 146.678 9.84051 147.089C10.2085 147.126 10.5825 147.146 10.9605 147.146H28.3905V118.756H-0.000488281Z"
        fill="#431FAF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.39 30.812L4.30302 49.232C2.26902 50.788 0.866023 52.987 0.290023 55.429C0.0990234 56.244 -0.000976562 57.085 -0.000976562 57.939V88.261L28.39 66.551V30.812Z"
        fill="#431FAF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M194 147H214V28H194V147Z"
        fill={theme()}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M242.657 146H262.188V60.9195H242.657V146ZM243.595 43.474C241.197 41.1906 240 38.35 240 34.9495C240 31.5517 241.197 28.7111 243.595 26.4259C245.99 24.1426 248.958 23 252.5 23C256.04 23 259.009 24.0899 261.406 26.2662C263.802 28.4443 265 31.1805 265 34.4721C265 37.977 263.829 40.9238 261.485 43.3143C259.141 45.7047 256.145 46.899 252.5 46.899C248.958 46.899 245.99 45.7582 243.595 43.474Z"
        fill={theme()}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M311.589 55.9594V61.0863H333.383V77.1077H312.231V146H292.143V77.1077H278V61.0863H292.143V55.6391C292.143 46.4548 294.819 39.217 300.178 33.9295C305.535 28.6429 313.088 26 322.838 26C330.553 26 336.605 27.5487 341 30.646L335.375 45.7065C331.944 43.3574 328.248 42.1811 324.285 42.1811C315.82 42.1811 311.589 46.7751 311.589 55.9594Z"
        fill={theme()}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M406 142.21C403.642 144.14 400.776 145.589 397.401 146.552C394.027 147.518 390.463 148 386.714 148C377.284 148 369.999 145.535 364.857 140.602C359.713 135.67 357.143 128.485 357.143 119.048V77.7087H343V61.6236H357.143V42H377.231V61.6236H400.214V77.7087H377.231V118.565C377.231 122.747 378.249 125.938 380.285 128.135C382.319 130.334 385.268 131.433 389.124 131.433C393.624 131.433 397.374 130.254 400.375 127.895L406 142.21Z"
        fill={theme()}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M438.125 81.7995C433.665 85.6071 430.953 90.6755 429.986 97.0021H478.82C477.959 90.7836 475.327 85.7409 470.924 81.8802C466.516 78.0186 461.036 76.0887 454.483 76.0887C448.037 76.0887 442.582 77.9939 438.125 81.7995ZM497.677 110.355H430.147C431.328 116.684 434.418 121.696 439.414 125.397C444.411 129.097 450.615 130.947 458.03 130.947C467.483 130.947 475.275 127.838 481.399 121.617L492.197 134.004C488.329 138.617 483.438 142.104 477.531 144.461C471.62 146.822 464.959 148 457.546 148C448.089 148 439.762 146.125 432.564 142.37C425.365 138.617 419.805 133.388 415.883 126.683C411.96 119.983 410 112.394 410 103.92C410 95.5543 411.907 88.0208 415.722 81.3166C419.535 74.6152 424.829 69.3864 431.598 65.6302C438.367 61.8786 445.994 60 454.483 60C462.864 60 470.359 61.8502 476.967 65.5514C483.575 69.2508 488.732 74.4539 492.439 81.1563C496.146 87.8595 498 95.6092 498 104.403C498 105.797 497.892 107.781 497.677 110.355Z"
        fill={theme()}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M565.74 127.573C569.593 125.385 572.643 122.261 574.89 118.2C577.136 114.142 578.259 109.444 578.259 104.101C578.259 98.7622 577.136 94.0632 574.89 90.0022C572.643 85.9448 569.593 82.8211 565.74 80.6308C561.889 78.4425 557.556 77.3455 552.741 77.3455C547.927 77.3455 543.593 78.4425 539.741 80.6308C535.89 82.8211 532.84 85.9448 530.593 90.0022C528.346 94.0632 527.223 98.7622 527.223 104.101C527.223 109.444 528.346 114.142 530.593 118.2C532.84 122.261 535.89 125.385 539.741 127.573C543.593 129.763 547.927 130.858 552.741 130.858C557.556 130.858 561.889 129.763 565.74 127.573ZM598 28V146.878H578.741V135.824C575.423 139.884 571.331 142.928 566.463 144.957C561.593 146.984 556.217 148 550.333 148C542.093 148 534.685 146.186 528.106 142.553C521.525 138.923 516.361 133.768 512.618 127.093C508.871 120.418 507 112.753 507 104.101C507 95.4504 508.871 87.8147 512.618 81.1912C516.361 74.5694 521.525 69.4425 528.106 65.8104C534.685 62.181 542.093 60.3632 550.333 60.3632C556.004 60.3632 561.192 61.3241 565.901 63.2469C570.608 65.1698 574.621 68.0526 577.938 71.8983V28H598Z"
        fill={theme()}
      />
    </svg>
  );
};
